import { BaseModel } from "./BaseModel";

export class Condition extends BaseModel {
  schema = "/condition";
  constructor(params) {
    return super(params, "/condition");
  }
}
